import Banner from '../../generic/Banner';
import { BannerAttention, BannerSize, BannerStyle } from '../../../../typings/enums';
import styles from './HybridProjectConnectionBanner.module.less';
import { BUTTON_SIZE, BUTTON_TYPE, NavigationButton } from '../../generic';
import { useToggle } from '../../../hooks';

const HybridProjectConnectionBanner = () => {
  const [shouldDisplayBanner, toggleShouldDisplayBanner] = useToggle(true);

  if (!shouldDisplayBanner) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Banner
        title="Receive automatic updates"
        body="This project appears to be tracked in GitHub. Would you like to connect it to a GitHub account to receive automatic updates based on changes to the repo?"
        isDismissible
        onDismiss={toggleShouldDisplayBanner}
        actions={
          <NavigationButton type={BUTTON_TYPE.PRIMARY} size={BUTTON_SIZE.SMALL} to="/projects/import/github-app">
            Connect Project
          </NavigationButton>
        }
        bannerStyle={BannerStyle.Info}
        bannerSize={BannerSize.Small}
        bannerAttention={BannerAttention.Low}
      />
    </div>
  );
};

export default HybridProjectConnectionBanner;
